// extracted by mini-css-extract-plugin
export default {"container":"EmailVerified_container__SHk1J","icon":"EmailVerified_icon__Jh3XB","title":"EmailVerified_title__rRCuB","message":"EmailVerified_message__LeHts"};